/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "../analytics/analytics";

export default baustein.register("notification", {
    async onInsert() {
        if (this.options.type && this.options.productSlug) {
            await analytics.event("saw", this.options.type, this.options.productSlug);
        }
    }
});

